import { render, staticRenderFns } from "./tagSelect.vue?vue&type=template&id=2dc95e73"
import script from "./tagSelect.vue?vue&type=script&lang=js"
export * from "./tagSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dc95e73')) {
      api.createRecord('2dc95e73', component.options)
    } else {
      api.reload('2dc95e73', component.options)
    }
    module.hot.accept("./tagSelect.vue?vue&type=template&id=2dc95e73", function () {
      api.rerender('2dc95e73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/select/tagSelect.vue"
export default component.exports